import DashboardPage from '../components/dashboard/dashboardPage';
import NewClaimPage from '../components/disputeMgmt/newClaim/newClaimPage';
import DisputesPage from '../components/disputeMgmt/disputes/disputesPage';
import Constants from './constants';

export default {
    DASHBOARD_ROUTE: {
        key : "dashboard",
        name : "Dashboard",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/dashboard`,
        pageComponent: DashboardPage
    },
    NEW_CLAIM_ROUTE: {
        key : "newclaim",
        name : "New Claim",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/newclaim`,
        pageComponent: NewClaimPage
    },
    DISPUTES_ROUTE: {
        key: "disputes",
        name : "Disputes",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/disputes`,
        pageComponent: DisputesPage
    }
}


// WEBPACK FOOTER //
// ./src/configurations/routesConfig.js